const listTypeLabels = {
  movie: {
    singular: 'Movie',
    plural: 'Movies',
  }
};

export {listTypeLabels};